(function (Drupal, $) {
  Drupal.behaviors.card_basic = {
    attach: function (context) {
      $(function() {

        var resizeIntroText = function(elem, mobile, desktop) {
          elem.find('.card-list>.card__wrapper').each(function() {
            var intro = $(this).find('.card__intro >p:first-of-type');
            var intro_height = intro.height();
            
            if($(window).width() < 1024) {
              while (intro_height > mobile) {
                intro.text(intro.text().split("").slice(0, -3).join("") + "…");
                intro_height = intro.parent().height();
              }
            }
            else {
              while (intro_height > desktop) {
                intro.text(intro.text().split("").slice(0, -3).join("") + "…");
                intro_height = intro.parent().height();
              }
            }
          });
  
          elem.find('.card-list>.card__wrapper').each(function(index) {
            var $this = $(this);
            setTimeout(function() {
              $this.css({
                'opacity': '1',
              });
            }, 125+ 125*index);
          });
        }

        resizeIntroText($('.paragraph-link-cards__content'), 115, 90);
        resizeIntroText($('.paragraph-latest-news__content'), 115, 115);
      });      
    }
  }
})(Drupal, jQuery);